module.exports = __webpack_public_path__ + "img/case-dispatch-strategy.50d7c7f8.png";